export enum CreativeLinkHandlerEvents {
  IMAGE_PREVIEW = 'imagePreview',
  REFERRAL_PREVIEW = 'referralPreview',
  REFERRAL_COPY = 'referralCopy',
  DOWNLOAD_IMAGE = 'downloadImage',
}
